import { HeartPulse, Siren, ArrowRight, Download, UserRoundPlus, Compass, MessagesSquare, PartyPopper } from "lucide-react";
import { HOME } from "@/constants/testIds";

export function Safety() {
  return (
    <section id="safety" className="py-20 md:py-28">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-red-50 text-red-600 px-4 py-1.5 text-xs font-semibold">
            Community Safety
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-bold text-[#1A1918] leading-tight">
            When seconds matter, <br />
            <span className="brand-gradient-text">your city has your back.</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="rounded-3xl border border-red-100 bg-gradient-to-br from-red-50 to-white p-8">
            <div className="w-12 h-12 rounded-2xl bg-red-500 flex items-center justify-center">
              <HeartPulse className="w-6 h-6 text-white" />
            </div>
            <h3 className="mt-4 text-2xl font-bold text-[#1A1918]">Blood Requests</h3>
            <p className="mt-3 text-[#4A4846] leading-relaxed">
              Notify nearby people during blood emergencies. Filter by group and hospital,
              connect to volunteers within minutes.
            </p>
            <a
              href="#download"
              data-testid={HOME.ctaSafetyLearnMore}
              className="mt-6 inline-flex items-center gap-2 text-red-600 font-semibold text-sm hover:gap-3 transition-all"
            >
              Learn more <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          <div className="rounded-3xl border border-red-100 bg-gradient-to-br from-red-50 to-white p-8">
            <div className="w-12 h-12 rounded-2xl bg-red-500 flex items-center justify-center">
              <Siren className="w-6 h-6 text-white" />
            </div>
            <h3 className="mt-4 text-2xl font-bold text-[#1A1918]">SOS Safety</h3>
            <p className="mt-3 text-[#4A4846] leading-relaxed">
              Alert trusted contacts with your latest location during emergencies.
              One tap. Full location trail. Instant peace of mind.
            </p>
            <a
              href="#download"
              className="mt-6 inline-flex items-center gap-2 text-red-600 font-semibold text-sm hover:gap-3 transition-all"
            >
              Learn more <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

const steps = [
  { icon: Download, t: "Download the App", d: "Get Time2Cash from the Play Store — free, lightweight, fast." },
  { icon: UserRoundPlus, t: "Create Your Profile", d: "Verify with OTP and set your neighbourhood location." },
  { icon: Compass, t: "Choose Your Need", d: "Post a need, find a job, list your shop, or browse the marketplace." },
  { icon: MessagesSquare, t: "Connect Locally", d: "Chat, call, or WhatsApp directly — no middlemen." },
  { icon: PartyPopper, t: "Get Things Done", d: "From a broken pipe to a full-time job — solved, locally." },
];

export function HowItWorks() {
  return (
    <section className="py-20 md:py-28 bg-[#FFF9F5]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white border border-[#EBE8E3] px-4 py-1.5 text-xs font-semibold text-[#4A4846]">
            How It Works
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-bold text-[#1A1918] leading-tight">
            From download to done in <span className="brand-gradient-text">five taps.</span>
          </h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute top-6 left-8 right-8 h-0.5 bg-[#FF5A00]/20" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map(({ icon: Icon, t, d }, i) => (
              <div key={t} className="relative bg-white rounded-3xl border border-[#EBE8E3] p-6">
                <div className="w-12 h-12 rounded-full bg-[#FF5A00] text-white font-black flex items-center justify-center text-lg relative z-10">
                  {i + 1}
                </div>
                <Icon className="w-6 h-6 text-[#FF5A00] mt-4" />
                <h4 className="mt-3 font-bold text-[#1A1918]">{t}</h4>
                <p className="mt-1 text-sm text-[#4A4846] leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
